import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import SmsCard from 'components/cards/SmsCard/SmsCard'
import NoData from 'components/general/NoData/NoData'
import Sms from 'models/Sms'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { useParams } from 'react-router-dom'
import { useFetchList } from 'store'

import styles from './widgets.module.sass'

const SmsWidget = () => {
	const { clinicalProcessId } = useParams()
	const { i18n } = useGlobal()

	const smsUri = `/clinical_processes/${clinicalProcessId}/sms`
	const { contents, isLoading } = useFetchList([smsUri], [Sms.fromJSON])

	const [smsContent = []] = contents || []
	const sms = smsContent || []

	return (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			icon='chat-bubble'
			title={i18n`SMS`}
			expanded={!!sms.length}
			expandable={!!sms.length}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			{!sms.length ? (
				<NoData
					applyMaxWidth
					paddings={['normal', 'normal']}
					message={
						isLoading
							? i18n`Loading`
							: i18n`This process has no SMS to show.`
					}
				/>
			) : (
				<div className={styles['sms-scroller']}>
					{sms.map((item) => <SmsCard key={item.id} data={item} />)}
				</div>
			)}
		</ExpandableWidget>
	)
}

export default SmsWidget
